<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                     <v-btn dark icon title="Back to previous page" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="viewedByOwner" dark icon title="View in My Attendance" @click="viewInMyAttendance">
                        <v-icon>access_time</v-icon>
                    </v-btn>  
                    <v-chip v-if="frozenPeriod" label small class="warning" dark title="This period is already Frozen. You will not be able to change this record.">Frozen</v-chip>
                    <v-chip v-if="closedPeriod" label small class="grey darken-2" dark title="This period is already Closed. You will not be able to change this record.">Closed</v-chip>
                    
                    <v-menu v-if="showMenu" left v-model="menu_status" offset-y :disabled="isMenuDisabled">
                        <template v-slot:activator="{ on }">
                            <v-btn :color="commonfn.getStatusButtonColor(timeoff_detail.status)" dark v-on="on" :loading="loading_status" class="mr-0">
                                <span class="ml-7">
                                    {{ commonfn.getStatusDescription(timeoff_detail.status) }}
                                </span>
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-for="(item, index) in menuItems" :key="index" @click="item.action">
                                <v-list-tile-title small>{{ item.label }}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>

                    <!-- fallback -->
                    <v-btn v-else-if="!loading" :color="commonfn.getStatusButtonColor(timeoff_detail.status)" dark class="mr-0">
                        {{ commonfn.getStatusDescription(timeoff_detail.status) }}
                    </v-btn>

                </v-toolbar>
            </v-card>
            <v-alert v-if="!loading && approved_Timesheet" :value="true" color="warning" icon="warning" outline class="mt-8">
                The timesheet for this period is already <b>Approved</b>. You will not be able to change this record.
            </v-alert>
           
            <!-- DETAILS -->
            <v-card v-if="!loading" class="elevation-1 mt-10 mb-10">
                <v-toolbar flat height="35px" class="font-weight-bold">
                    <span class="primary--text">DETAILS</span>
                    <v-spacer></v-spacer>
                    <help-link appId="attendance" :pageId="helpPageId" color="black"></help-link>
                </v-toolbar>
                <v-layout row wrap> 
                    <v-flex xs12 sm6>
                        <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row mt-5'"> 
                            <v-flex xs4 class="text-xs-left">
                                Requested By :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                <v-chip small @click="viewUserProfile(timeoff_detail, $store.state.userId)" class="user-chip-container">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(timeoff_detail.userId)"></v-img>
                                    </v-avatar>
                                    {{timeoff_detail.firstName}} {{timeoff_detail.lastName}}
                                </v-chip>
                            </v-flex>  
                        </v-layout>
                        <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row'"> 
                            <v-flex xs4 class="text-xs-left">
                                Date :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{timeoff_detail.transDate|moment('dddd, DD MMM YYYY')}}
                            </v-flex>  
                        </v-layout>     
                        <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row'"> 
                            <v-flex xs4 class="text-xs-left">
                                Leave Type :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                 {{timeoff_detail.leaveName}}
                            </v-flex>  
                        </v-layout> 
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row  mt-5'"> 
                            <v-flex xs4 class="text-xs-left">
                                Hours (Decimal):
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{timeoff_detail.hours}}
                            </v-flex>  
                        </v-layout>     
                        <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row  mt-5'"> 
                            <v-flex xs4 class="text-xs-left">
                                Hours & Minutes:
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{decimalHoursToHoursMinutes(timeoff_detail.hours)}}
                            </v-flex>  
                        </v-layout> 
                        <v-layout row wrap :class="isMobile? 'content-row-mobile mb-5' : 'content-row'"> 
                            <v-flex xs4 class="text-xs-left">
                                Remarks: 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                 {{timeoff_detail.remarks}}
                            </v-flex>  
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>

            <!-- ATTACHMENTS -->
            <v-card v-if="!loading" class="elevation-1 mt-10"> 
                <v-toolbar flat height="35px">
                    <span class="font-weight-bold primary--text">ATTACHMENTS</span>
                    <v-spacer></v-spacer>
                    <v-btn v-if="enableForEditRights" icon title="Add Attachments" @click="showUpload">
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="attachments"
                    :hide-actions="attachments.length<6"
                    :loading="loading_attachment"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr>
                            <td @click="previewAttachment(props.item)" style="cursor:pointer;" title="Click to preview file">
                                <span class="clickable wrapped-filename">
                                    {{ props.item.fileName }}
                                </span>
                            </td>
                            <td>{{ props.item.createdOn | moment('MMM DD, YYYY') }}</td>
                            <td>
                                <v-btn v-if="enableForEditRights" icon title="Delete Attachment" @click="showDeleteAttachment(props.item)" :disabled="loading_attachment">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </td> 
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
            
            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="selectedTimeOffId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogPTO" width="500" persistent>   
            <pto-component ref="ptoComponentRef" :enableDateRange="false" @send="getTimeOffById(false)" :dialogPTO.sync="dialogPTO"></pto-component>
        </v-dialog>
        <v-dialog v-model="dialogUpload" fullscreen hide-overlay transition="dialog-bottom-transition"> 
            <upload ref="uploadRef" :dialogUpload.sync="dialogUpload" @send="getTimeOffById(false)"></upload>
        </v-dialog>
        <v-dialog v-model="dialogPreview" fullscreen hide-overlay transition="dialog-bottom-transition">
            <preview ref="refPdfPreviewComponet" :dialogPreview.sync="dialogPreview"></preview>
        </v-dialog>
        <v-dialog v-model="dialogDelete" width="500">
            <delete ref="refDeleteComponent" :dialogDelete.sync="dialogDelete" @okDelete="deleteHandler"></delete>
        </v-dialog>
        <v-dialog v-model="dialogTeamSelector" width="700">
            <team-selector :teams="matchingTeams" :dialogTeamSelector.sync="dialogTeamSelector"></team-selector>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="selectedTimeOffId" @refresh="updateHandler"></status-messaging>
    </v-layout>  
</template>

<script>

import { syncTeamContext } from '@/helpers/team-selector'
import timeOffApi from '@/api/timeoffs'
import commonfn from '@/common/functions'   //for refactor
import AppPageID from '@/constants/app_page_ids'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import awsS3Helper from '@/helpers/aws-s3'
import AWSS3DocumentType from '@/constants/aws-s3-document-types'
import { hasDeleteRights, hasEditRights } from '@/helpers/access-permissions'
import { hasTeamEditRights, hasTeamDeleteRights, hasTeamApproverRights, hasTeamSelfApproverRights } from '@/helpers/myteams-permissions'
import { decimalHoursToHoursMinutes } from '@/helpers/time-converter'

export default {     
    name: 'TimeOff',
    metaInfo: {
        title: 'My Time Off',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'My Time Off' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'pto-component': () => import('@/components/TimeOff/AddEditTimeOff'),
        'upload': () => import('@/components/TimeOff/AddAttachments'),
        'preview': () => import('@/components/FilePreview/Preview'),
        'delete': () => import('@/components/BasicPopups/Delete'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory'),
        'team-selector': () => import('@/components/Team/TeamSelector')
    },   
    data () {
        return {
            commonfn,
            awsS3Helper,
            error: false,
            errorMessage: '',
            loading: false,
            loading_delete: false,
            loading_status: false,
            loading_attachment: false,
            loading_delete_attachment: false,
            headers: [
                {text: 'File',align: 'left',value: 'name', width: '70%', sortable:false},
                {text: 'Created On',align: 'left',value: 'status',  width: '25%', sortable:false},
                {text: '',align: 'left',value: '',  width: '5%', sortable:false}
            ],
            deleteFunction: null,
            menu_status: false,
            message: null,
            dialogDelete: false,
            dialogUpload: false,
            dialogPreview: false,
            cutoff_details: null,
            timeoff_detail: null,
            deleteTimeOffAttachmentId: null,
            dialogPTO: false,
            attachments: [],
            dialogTeamSelector: false,
            matchingTeams: []
        }
    },
    methods: { 
        decimalHoursToHoursMinutes,
        showDeleteTimeOff() {
            this.$refs.refDeleteComponent.setMessage("Delete this Time Off request?")
            this.dialogDelete = true
            this.deleteFunction = () => this.deleteTimeOff()
        },
        showDeleteAttachment(data) {
            this.deleteTimeOffAttachmentId = data.timeOffAttachmentId
            this.$refs.refDeleteComponent.setMessage("Delete this attachment?")
            this.dialogDelete = true
            this.deleteFunction = () => this.deleteAttachment()
        },
        deleteHandler() {
            if (typeof this.deleteFunction === 'function') {
                this.deleteFunction()
                this.dialogDelete = false
            }
        },
        async deleteAttachment() {
            try {
                this.loading_attachment = true
                const response = await timeOffApi.deleteAttachment(this.deleteTimeOffAttachmentId)
                if (response && response.status == 200) {
                    await this.getTimeOffById(false)                    
                }
                this.loading_attachment = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async previewAttachment(item) {
            try {
                this.loading_attachment = true 
                const response = await timeOffApi.getAttachmentUrl(this.timeoff_detail.userId, item.fileName)
                if (response && response.status == 200) {
                    var file = {
                        name: response.data.fileName,
                        type: 'Pdf',
                        url: response.data.url,
                        downloadUrl: awsS3Helper.getEmployeeDocumentUrl(this.timeoff_detail.userId, response.data.fileName, AWSS3DocumentType.TimeOffAttachment)
                    }
                    this.$refs.refPdfPreviewComponet.setParams(file)
                    this.loading_attachment = false
                    this.dialogPreview = true
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        showUpload(){
            const data = {
                userId: this.timeoff_detail.userId,
                timeOffId: this.selectedTimeOffId
            }
            this.$refs.uploadRef.setData(data)
            this.dialogUpload = true
        },
        viewUserProfile(data, loggedInUserId) {
            if (data.userId == loggedInUserId)
                this.$router.push(`/myprofile`)
            else 
                this.$router.push(`/hr/employees/${data.userId}`)
        },
        async setForReview() {
            try {
                this.loading_status = true
                var data = {
                    timeOffId: this.timeoff_detail.timeOffId
                }
                const response = await timeOffApi.forReview(data) //only pageOwner has access
                if (response && response.status == 200) {
                    await this.getTimeOffById(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async approve() {
            try {
                this.loading_status = true
                var data = {
                    timeOffId: this.timeoff_detail.timeOffId
                }
                const response = await timeOffApi.approve(data, this.userPageKey)
                if (response && response.status == 200) {
                    await this.getTimeOffById(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async reject() {
            try {
                this.loading_status = true
                var data = {
                    timeOffId: this.timeoff_detail.timeOffId
                }
                const response = await timeOffApi.reject(data, this.userPageKey)
                if (response && response.status == 200) {
                    await this.getTimeOffById(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        showEditTimeOff() {
            var data = {
                    timeOffId: this.timeoff_detail.timeOffId,
                    userId: this.timeoff_detail.userId,
                    withPTO: true,
                    mode: 'Edit',
                    transDate: this.timeoff_detail.transDate,
                    workShift: `${this.timeoff_detail.workShift} (${this.$moment(this.timeoff_detail.clockStart).format('h:mm a')} - ${this.$moment(this.timeoff_detail.clockEnd).format('h:mm a')})`,
                    duration: this.timeoff_detail.duration,
                    type: this.timeoff_detail.type,
                    hours: this.timeoff_detail.hours,
                    status: this.timeoff_detail.status,
                    remarks: this.timeoff_detail.remarks,
                    updatedBy: this.timeoff_detail.updatedBy,
                    updatedByName: this.timeoff_detail.updatedByName,
                    updatedByRemarks: this.timeoff_detail.updatedByRemarks,
                    updatedOn: this.timeoff_detail.updatedOn,
                    isRequestForOtherUser: !this.viewedByOwner
                }
            this.$refs.ptoComponentRef.setParams(data)
            this.dialogPTO = true
        },
        async deleteTimeOff() {
            try {
                this.loading_status = true
                var data = {
                    timeOffId: this.timeoff_detail.timeOffId
                }
                const response = await timeOffApi.delete(data)
                if (response && response.status == 200) {
                    this.loading_status = false
                    this.dialogDelete = false
                    this.$router.go(-1)
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        viewInMyAttendance() {
            this.$router.push(`/myattendance/daily/${this.$moment(this.timeoff_detail.transDate).format('YYYY-MM-DD')}`)
        },
        async getTimeOffById(show_loading) {
            try {
                this.loading = show_loading
                const response = await timeOffApi.getById(this.selectedTimeOffId, this.userPageKey)
                if (response && response.status == 200) {
                    this.timeoff_detail = response.data.timeOffsItem
                    this.cutoff_details = response.data.cutoffItem
                    this.attachments = response.data.timeOffsItem.attachments
                }
                this.loading = false
                this.dialogPTO = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getTimeOffById(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Time Off Details'
        })

        await this.getTimeOffById(true)
        
        const result = await syncTeamContext(this.timeoff_detail.userId)
        if (result && result.action === 'SHOW_DIALOG') {
            this.matchingTeams = result.teams
            this.dialogTeamSelector = true
        }
    },
    computed: {
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path) ||
                hasTeamEditRights(AppPageID.TeamTimeOff)
        },
        hasDeleteRights() {
            return hasDeleteRights(this.$router.currentRoute.path)
        },
        hasTeamApproverRights() {
            return hasTeamApproverRights(AppPageID.TeamTimeOff)
        },
        hasTeamSelfApproverRights() {
            return hasTeamSelfApproverRights(AppPageID.TeamTimeOff)
        },
        hasTeamDeleteRights() {
            return hasTeamDeleteRights(AppPageID.TeamTimeOff)
        },
        hasEditAndApprover() {
            return this.hasEditRights && this.hasTeamApproverRights
        },
        isMenuDisabled() {
            return this.frozenPeriod || this.closedPeriod || this.approved_Timesheet
        },
        menuItems() {
            if (!this.timeoff_detail) return []

            const items = []

            // ACTION-BASED PERMISSIONS (no grouping)
            const canEdit =
                this.hasEditRights &&
                (this.created_status || this.rejected_status)

            const canDelete =
                (this.hasDeleteRights || this.hasTeamDeleteRights) &&
                (this.created_status || this.rejected_status)

            const canForReview =
                this.hasEditRights &&
                this.created_status

            const canApprove = this.viewedByOwner ?
                this.hasTeamSelfApproverRights && (this.forReview_status || this.rejected_status) :
                this.hasTeamApproverRights && (this.forReview_status || this.rejected_status)

            const canReject = this.viewedByOwner ?
                this.hasTeamSelfApproverRights && (this.forReview_status || this.approved_status) :
                this.hasTeamApproverRights && (this.forReview_status || this.approved_status)

            if (canDelete) {
                items.push({ label: 'Delete', action: this.showDeleteTimeOff })
            }

            if (canEdit) {
                items.push({ label: 'Edit', action: this.showEditTimeOff })
            }

            if (canForReview) {
                items.push({ label: 'For Review', action: this.setForReview })
            }

            if (canApprove) {
                items.push({ label: 'Approve', action: this.approve })
            }

            if (canReject) {
                items.push({ label: 'Reject', action: this.reject })
            }

            return items
        },
        showMenu() {
            return !this.loading && this.menuItems.length > 0
        },
        pageLink() {
            if (this.timeoff_detail) {
                if (this.viewedByOwner) {
                    if (this.$router.currentRoute.path.includes('company/timeoff')) {
                        return `company${this.$router.currentRoute.path.replace('/myattendance','')}`
                    }else{
                        return `myteam${this.$router.currentRoute.path.replace('/myattendance','')}`
                    }
                }else{
                    return `myattendance${this.$router.currentRoute.path.replace('/myteam','').replace('/company','')}`
                }
            }
        },
        commentsData() {            
            if (this.timeoff_detail) {
                return {
                    pageQueryId: this.selectedTimeOffId,
                    pageItemCreatedBy: this.timeoff_detail.userId,
                    pageLink: this.pageLink,
                    pageKey: pageKeys.timeoff_team_approver,
                    notificationTypeId: notificationTypes.timeoff
                }
            }
        },
        selectedTimeOffId() {
            return this.$route.params.timeOffId
        },
        viewedByOwner() {
            if (this.timeoff_detail)
                return this.$store.state.userId == this.timeoff_detail.userId
        },
        userPageKey() {
            if (this.$router.currentRoute.path.includes('company/timeoff')) {
                return pageKeys.timeoff_company_approver
            }else if (this.$router.currentRoute.path.includes('myteam/timeoff')) {
                return pageKeys.timeoff_team_approver
            }else{
                return pageKeys.timeoff
            }
        },
        frozenPeriod(){
            if (this.cutoff_details)
                return this.cutoff_details.status==commonfn.getStatusCode('Frozen')
        },
        closedPeriod(){
            if (this.cutoff_details)
                return this.cutoff_details.status==commonfn.getStatusCode('Closed')
        },
        created_status() {
            if (this.timeoff_detail)
                return this.timeoff_detail.status==commonfn.getStatusCode('Created')
        },
        deleted_status() {
            if (this.timeoff_detail)
                return this.timeoff_detail.status==commonfn.getStatusCode('Deleted')
        },
        forReview_status() {
            if (this.timeoff_detail)
                return this.timeoff_detail.status==commonfn.getStatusCode('For Review')
        },
        approved_status() {
            if (this.timeoff_detail)
                return this.timeoff_detail.status==commonfn.getStatusCode('Approved')
        },
        rejected_status() {
            if (this.timeoff_detail)
                return this.timeoff_detail.status==commonfn.getStatusCode('Rejected')
        },
        approved_Timesheet() {
            if (this.cutoff_details)
                return this.cutoff_details.timeReportStatus==commonfn.getStatusCode('Approved')
        },
        helpPageId() {
            if (this.viewedByOwner) {
                return 'timeoff-page'
            }else{
                if (this.$router.currentRoute.path.includes('company')) {
                    return 'timeoff-review-company'
                }else{
                    return 'timeoff-review-team'
                }
            }
        },
        enableForEditRights() {
            return this.hasEditRights &&
                    !this.frozenPeriod &&
                    !this.closedPeriod &&
                    (this.created_status||this.rejected_status)
        }
    }
}
</script>
<style scoped>
.content-row-mobile {
    padding:0px 20px 0px 20px;
}
.content-row {
    padding:0px 20px 0px 50px;
}
</style>